<template>
  <div class="col-sm-3 cart-summary">
    <div class="cart-sidebar shadow-box">
      <div class="wrap-subtotal">
        <h4>Cart Total</h4>
        <div class="subtotal-price">
          {{ (totalItems === 1 ? totalItems + ' item @ ' : totalItems + ' items @ ') + '$' + itemTotal}}
        </div>

        <button
          id="express-checkout-btn"
          class="btn btn-block btn-orange"
          @click="loadExpressCheckout"
          :disabled="loadingCheckout || showNoItems || updatingQuantities" v-show="qualifiesForExpressCheckout"
        >
          {{ showNoItems ? 'No items in cart' : updatingQuantities ? 'Updating cart...' : 'Express Checkout' }}
          &nbsp;&nbsp;
          <i class="fa fa-spin fa-spinner" v-if="updatingQuantities || loadingCheckout"></i>
        </button>

        <button
          class="btn btn-block btn-light-green"
          @click.prevent="checkout"
          :disabled="loadingCheckout || showNoItems || updatingQuantities"
        >
          {{ showNoItems ? 'No items in cart' : updatingQuantities ? 'Updating cart...' : 'Checkout' }}
          &nbsp;&nbsp;
          <i class="fa fa-spin fa-spinner" v-if="updatingQuantities || loadingCheckout"></i>
        </button>

        <span class="cc-types col-sm-12 text-center">
          <i class="fa fa-cc-visa" aria-hidden="true" alt="Visa" title="Visa"></i>
          <i class="fa fa-cc-mastercard" aria-hidden="true" alt="Mastercard" title="Mastercard"></i>
          <i class="fa fa-cc-amex" aria-hidden="true" alt="Amex" title="Amex"></i>
          <i class="fa fa-cc-discover" aria-hidden="true" alt="Discover" title="Discover"></i>
        </span>
      </div><!-- /wrap-subtotal -->

      <br>

      <h4>Shipping Estimate</h4>
      <div class="form-wrap" id="calculateShipping" v-show="showShippingForm">
        <form>
          <div class="form-group">
            <label>Country</label>
            <span class="styled-select">
              <select name="country"
                      id="country"
                      v-model="country"
                      class="form-control"
                      v-validate="'required'">
                <option value="USA">United States</option>
                <option value="CAN">Canada</option>
                <option disabled>--------------</option>
                <option v-for="country in countries" :value="country.code" :key="country.index">
                  {{ country.long_name }}
                </option>
              </select>
            </span><!-- /styled-select -->
          </div><!-- /form-group -->
          <div class="form-group">
            <label>Enter Postal Code</label>
            <input type="text" name="postal_code" v-model="postal_code" @input="postal_code = formatPostalCode($event.target.value)" class="form-control">
          </div><!-- /form-group -->
          <div class="form-group">
            <button type="submit" name="get_estimate" id="btnGetEstimate" class="btn btn-block btn-black"
            @click.prevent="getShippingEstimate" :disabled="loadingShipping">
            GET ESTIMATE <i v-if="loadingShipping" class="fa fa-spin fa-spinner"></i>
            </button>
          </div><!-- /form-group -->
        </form>
      </div><!-- /form-wrap -->
      <div class="get-estimate" id="getEstimate" v-show="!showShippingForm">
        <div class="row">
          <div class="col-xs-12" v-if="localDistributor">
            <div class="estimate-info" v-for="shippingOption in upsShippingOptions"
                :key="shippingOption.shipping_time">
              <div class="shipping-option" style="width: 100%;">
                  {{ shippingOption.name }}
              </div>
            </div><!-- /estimate-info -->
          </div>
          <div class="col-xs-12" v-if="fedexUps && !isOverweight && !localDistributor">
            <div class="estimate-info" v-for="shippingOption in upsShippingOptions"
                :key="shippingOption.shipping_time">
              <div class="shipping-option" v-if="shippingOption.shipping_time === 2 && !shippingOption.code.includes('_international') && shippingOption.code !== 'fast_pass'">
                <span style="background-color: #13ae47;font-size: 14px;padding-left: 0.6em;padding-right:0.6em;margin-right: 0.6em;border-radius: 6px;">
                  2 Day Air
                </span>
              </div>
              <div class="shipping-option" v-else-if="shippingOption.shipping_time === 3 && !shippingOption.code.includes('_international') && shippingOption.code !== 'fast_pass'">
                3 Day Air
              </div>
              <div class="shipping-option" v-else>
                {{ shippingOption.short_name === 'Ground' ? shippingOption.short_name + ' (transit time 4-7 Business Days)' : shippingOption.short_name }}
              </div>
              <div class="shipping-price">
                ${{ shippingOption.rate.amount }}
              </div>
            </div><!-- /estimate-info -->
            <div class="estimate-info" v-for="shippingOption in fedexShippingOptions"
                :key="shippingOption.shipping_time">
              <div class="shipping-option">
                {{ shippingOption.short_name }}
              </div>
              <div class="shipping-price">
                ${{ shippingOption.rate.amount }}
              </div>
            </div>
            <div class="estimate-info" v-if="country === 'CAN' ? !fedexShippingOptions.length : !upsShippingOptions.length">
              <div class="shipping-option">N/A - <span>0 day(s)</span></div>
            </div><!-- /estimate-info -->
          </div>
          <div class="col-xs-12" v-if="otherShipping && !isOverweight && !localDistributor">
            <div class="estimate-info" v-for="shippingOption in otherShippingOptions"
                :key="shippingOption.shipping_time">
              <div class="shipping-option">
                  {{ shippingOption.short_name }}
              </div>
              <div class="shipping-price">
                ${{ shippingOption.rate.amount }}
              </div>
            </div><!-- /estimate-info -->
          </div>
          <div class="col-xs-12" v-if="contactNicShipping">
            <div class="estimate-info" v-for="shippingOption in otherShippingOptions"
                :key="shippingOption.name">
              <div class="shipping-option">
                Contact NIC<br>
                {{ shippingOption.short_name }}<br>
                <a href="tel:1-866-774-7628">1-866-774-7628</a>
              </div>
            </div><!-- /estimate-info -->
          </div>
          <div class="col-xs-12" v-if="swatchShippingOptions.length">
            <h4 style="text-align:left">Swatch Shipping</h4>
            <div class="estimate-info" v-for="shippingOption in swatchShippingOptions"
                :key="shippingOption.index">
              <div class="shipping-option">
                {{ shippingOption.name }}
              </div>
              <div class="shipping-price">
                ${{ shippingOption.rate.amount }}
              </div>
            </div><!-- /estimate-info -->
          </div>
        </div><!-- /row -->
        <a href="#" class="btn btn-blue btn-block" id="btnRecalculate" @click.prevent="showShippingForm = true">
          Recalculate Shipping</a>
      </div><!-- /get-estimate -->

      <div class="link-terms">
        <a :href="`/terms-and-policies#shipping`" target="_blank">
          <i class="fa fa-question-circle" aria-hidden="true"></i>
          <span>Terms and Conditions</span>
        </a>
      </div>

    </div><!-- /cart-sidebar -->
  </div><!-- /col-sm-4 -->
</template>

<script>
  import shopPricing from '../../mixins/shop_pricing';
  import formatting from '../../mixins/formatting';
  import countries from '../../mixins/countries';

  export default {
    name: 'cart-details',

    props: {
      subTotal: String,
      totalItems: Number,
      cartItems: Array,
      updatingQuantities: Boolean,
      hasInvalidQuantities: Boolean
    },

    mixins: [
      shopPricing,
      formatting,
      countries
    ],

    data() {
      return {
        country: 'USA',
        countries: [],
        postal_code: '',
        showShippingForm: true,
        shippingOptions: {
          result: []
        },
        shipOptionCount: 0,
        fedexShippingOptions: [],
        upsShippingOptions: [],
        localShippingOptions: [],
        otherShippingOptions: [],
        swatchShippingOptions: [],
        loadingCheckout: false,
        loadingShipping: false,
        fedexUps: false,
        localDistributor: false,
        contactNicShipping: false,
        otherShipping: false,
        waitingForLogIn: false,
        goToCheckout: false,
        isOverweight: false,
        forceDistributor: false
      }
    },

    computed: {
      showNoItems() {
        return this.totalItems === 0;
      },
      isLoggedIn() {
        return this.$root.isLoggedIn;
      },
      me() {
        return this.$root.me;
      },
      itemTotal() {
        return this.subTotal;
      },
      /**
       * @function qualifiesForExpressCheckout
       * @summary to display the express checkout option:
       * @summary user = logged in + has checkout session + has a primary address & primary phone.
       */
      qualifiesForExpressCheckout() {
        return (
          this.$root.isLoggedIn &&
          Object.values(this.$root.me.primary_address) &&
          this.$root.me.primary_phone !== null
        );
      }
    },

    watch: {
      isLoggedIn(loggedIn) {
        if (loggedIn) {
          this.checkLoginData();
        }
      },
    },

    mounted() {
      let vm = this;
      vm.getCountries();

      $('#informationModal').on('hidden.bs.modal', () => {
        if (this.$root.showResendVerification) {
          this.$root.showResendVerification = false;
        }
      });

      if (!vm.isLoggedIn) {
        vm.waitingForLogIn = true;
      }
    },

    methods: {
      async initiateExpressCheckoutSession() {
        await axios.post(`/api/proxify/domains/prismatic/shop/cart/checkout`)
        .then(({data: response}) => {
          let productData = [];

          // GA tracking.
          for (let product of response.order_items) {
            productData.push({
              name: product.name,
              id: product.sku,
              price: product.price.amount,
              brand: 'prismatic',
              quantity: product.quantity.value
            });
          }

          // GA tracking.
          window.dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
              'checkout': {
                'products': productData
              }
            }
          });

          this.$cookie.set('checkout_id', response.id, 7);
          this.$emit('setExpressCheckoutData', response);
        })
        .catch((error) => {
          const status = error.response.status;
          const apiMessage = error.response.data.message;

          if (status === 400 || status === 403) {
            this.$root.lockedTitle = 'Unable to Go To Checkout';
            this.$root.lockedMessage = apiMessage;
            this.$root.okCancel = false;
            this.$root.showResendVerification = false;

            if (status === 403 && apiMessage.toLowerCase().includes('verify') && apiMessage.toLowerCase().includes('email')) {
              this.$root.showResendVerification = true;
            }

            $('#express-checkout-modal').modal('hide');
            $('#informationModal').modal('show');
          } else {
            console.error(error);
          }
        })
      },

      // the express checkout button click to open the modal and start the api calls.
      loadExpressCheckout() {
        if (!this.isLoggedIn) {
          $('#logInLink').click();
          return;
        }

        $('#express-checkout-modal').modal({
          show: true,
          backdrop: 'static',
          keyboard: false
        });

        this.initiateExpressCheckoutSession();
      },

      async checkLoginData() {
        try {
          this.loadingCheckout = true;

          if (this.waitingForLogIn) {
            if (this.totalItems > 0) {
              // Check for cart changes and show message if needed
              if (this.$root.localCart.items.length) {
                this.$root.lockedTitle = 'Checkout Alert';
                this.$root.lockedMessage = '<strong>Please review the items in your cart!</strong><br>Your account had items that were combined with your current cart items';
                this.$root.okCancel = false;
                $('#informationModal').modal('show');
                this.loadingCheckout = false;
                return;
              }

              this.waitingForLogIn = false;
            }

            let isLocked = this.me != null && this.me.lock_reason && this.me.lock_reason.code == 'credit_hold';

            if (!this.isLoggedIn) {
              this.proceedToCheckout(isLocked);
            }
          } else if (this.isLoggedIn) {
            this.loadingCheckout = false;
          }

          if (this.goToCheckout) {
            let swatchItems = this.cartItems.filter(item => item.product.order_type === 'swatch' && item.product.sku.toLowerCase().endsWith('s'));

            if (swatchItems.length > 10) {
              this.$root.lockedMessage = 'You have more than 10 swatches in your cart.  You can only order 10 swatches per order.  Please remove swatches from your cart to be able to continue to checkout.';
              this.$root.lockedTitle = 'Checkout Alert';
              this.$root.okCancel = false;
              $('#informationModal').modal('show');
              this.loadingCheckout = false;
              return;
            }

            let isLocked = this.me != null && this.me.lock_reason && this.me.lock_reason.code == 'credit_hold';
            this.proceedToCheckout(isLocked);
          }

          this.loadingCheckout = false;
        } catch(e) {
          console.error(e);
        }
      },

      async getShippingEstimate() {
        const url = `/api/proxify/domains/prismatic/shop/cart/shipping-options?country=${this.country}&postal_code=${this.postal_code}`;

        this.loadingShipping = true;

        try {
            let response = await axios.get(url);
            this.resetShippingEstimate();
            this.setShippingOptions(response);

            this.showShippingForm = false;
        } catch (error) {
            const apiMessage = error.response.data.message;
            alert(apiMessage);
        } finally {
            this.loadingShipping = false;
        }
      },

      setShippingOptions(response) {
        this.shippingOptions = response.data;
        this.isOverweight = response.data.is_overweight;
        this.forceDistributor = response.data.alternative_checkout_via.is_forced;

        if (response.data.result.length) {
          for (const shippingOption of response.data.result) {
            if (shippingOption.code === 'local_distributor') {
                this.localDistributor = true;
            }
            if (shippingOption.code != 'fast_pass' && shippingOption.code != 'saturday') {
              if (shippingOption.provider === "fedex") {
                this.fedexShippingOptions.push(shippingOption);
                this.fedexUps = true;
              } else if (shippingOption.provider === "ups" || shippingOption.code === 'local_distributor') {
                this.upsShippingOptions.push(shippingOption);
                this.fedexUps = true;
              } else if (shippingOption.code === 'contact_nic') {
                this.otherShippingOptions.push(shippingOption);
                this.contactNicShipping = true;
              } else {
                this.otherShippingOptions.push(shippingOption);
                this.otherShipping = true;
              }
            }
          }
        }

        if (response.data.swatch_order_result.length) {
          this.swatchShippingOptions = response.data.swatch_order_result;
        }
      },

      resetShippingEstimate() {
        this.shipOptionCount = 0;
        this.fedexUps = false;
        this.localDistributor = false;
        this.otherShipping = false;
        this.contactNicShipping = false;
        this.fedexShippingOptions = [];
        this.upsShippingOptions = [];
        this.localShippingOptions = [];
        this.otherShippingOptions = [];
        this.swatchShippingOptions = [];
      },

      checkout() {
        if (this.isLoggedIn) {
          let lockCode = this.me.lock_reason ? this.me.lock_reason.code : null;
          let isLocked = lockCode && (lockCode === 'credit_hold' || lockCode === 'banned');

          this.loadingCheckout = true;
          this.proceedToCheckout(isLocked);
        } else {
          $('#logInLink').click();
          this.waitingForLogIn = true;
          this.goToCheckout = true;
        }
      },

      async proceedToCheckout(isLocked) {
        const url = `/api/proxify/domains/prismatic/shop/cart/checkout`;

        if (isLocked) {
          this.$root.lockedTitle = 'Unable to Go To Checkout';
          this.$root.lockedMessage = 'Your account has been suspended.  Please contact accounts receivable at 1-866-774-7628 to reactivate your account.';
          this.$root.okCancel = false;
          $('#informationModal').modal('show');
          this.waitingForLogIn = false;
          this.loadingCheckout = false;
        } else {
          try {
            let response = await axios.post(url, {});
            let productData = [];

            for (let product of response.data.order_items) {
              productData.push({
                name: product.name,
                id: product.sku,
                price: product.price.amount,
                brand: 'prismatic',
                quantity: product.quantity.value
              });
            }

            window.dataLayer.push({
              'event': 'checkout',
              'ecommerce': {
                'checkout': {
                  'products': productData
                }
              }
            });

            this.$cookie.set('checkout_id', response.data.id, 7);
            window.location.href = '/checkout';
          } catch(error) {
            const status = error.response.status;
            const apiMessage = error.response.data.message;
            const apiCode = error.response.data.code;

            if (status === 400 || status === 403) {
                this.$root.lockedTitle = 'Unable to Go To Checkout';
                this.$root.lockedMessage = apiMessage;
                this.$root.okCancel = false;
                this.$root.showResendVerification = false;

                if (status === 403 && apiMessage.toLowerCase().includes('verify') && apiMessage.toLowerCase().includes('email')) {
                  this.$root.showResendVerification = true;
                }

                $('#informationModal').modal('show');
                this.waitingForLogIn = false;
                this.loadingCheckout = false;
            }
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .cc-types {
    display: block;
    font-size: 3rem;
    color: #a9a9a9;
  }

  @media (max-width: 768px) {
    .cart-summary {
      position: inherit;
    }
  }
</style>
